module.exports = __webpack_public_path__ + "img/logo-big.07fb66b.png";